import i18n from '@/utils/i18n';
import { useCatalogCategoryItems } from './use-catalog-category-items';
import { useCatalogVariantPackGroups } from './use-catalog-variant-pack-groups';
import { useDynamicConfigValue } from './use-dynamic-config-value';
import { useMemo } from 'react';

export const useGeneratedCategories = ({ skip = false } = {}) => {
  const itemGroupsEnabled = useDynamicConfigValue('item_groups_enabled');

  // Generate categories if not provided via route params (for unified search)
  const { categoryItemsList, hasResponse } = useCatalogCategoryItems({ skip });
  const groups = useCatalogVariantPackGroups({
    skip: skip || !itemGroupsEnabled,
  });

  const categories = useMemo(() => {
    const sectionCategories = itemGroupsEnabled
      ? (groups ?? [])
      : categoryItemsList;
    return sectionCategories.map(({ category }) => ({
      ...category,
      name: category.name ?? i18n.t('other'),
    }));
  }, [categoryItemsList, groups, itemGroupsEnabled]);

  // Both sources return an empty list until their first response
  const loading = !skip && (itemGroupsEnabled ? groups === null : !hasResponse);

  return { categories, loading };
};
